<template>
  <b-card title="Asignar vehículo" :class="[dark ? 'dark-mode-page' : '']" >
    <b-row>
      <b-col>
        <div class="form-group">
          <label :class="[dark ? 'text-white': '']" >Placa</label>
          <input
            v-model="form.placa"
            type="text"
            disabled
            class="form-control form-control-sm"
            placeholder="Código"
          />
        </div>
      </b-col>
      <b-col md="4">
        <div class="form-group">
          <label :class="[dark ? 'text-white': '']" >Marca</label>
          <select
            class="form-control form-control-sm"
            v-model="form.marca"
            :disabled="disable.marca"
            >
            <option :value="null">Seleccione</option>
            <option
              :value="item.id_marca"
              v-for="(item, idx) in marcas"
              :key="idx"
            >
              {{ item.descripcion }}
            </option>
          </select>
        </div>
      </b-col>
      <b-col md="4">
        <div class="form-group">
          <label :class="[dark ? 'text-white': '']" >Tipo de vehículo</label>
          <Select2 v-model="form.tipo" :options="tvehiculos" :disabled="disable.type_vehicle" />
        </div>
      </b-col>
      <b-col md="4">
        <div class="form-group">
          <label :class="[dark ? 'text-white': '']" >Modelo</label>
          <input
            :disabled="disable.modelo"
            v-model="form.modelo"
            min="0"
            type="number"
            class="form-control form-control-sm"
            placeholder="0000"
          />
        </div>
      </b-col>
      <b-col md="4">
        <div class="form-group">
          <label :class="[dark ? 'text-white': '']" >Estado</label>
          <!-- <input
            :disabled="true"
            :class="
              'form-control form-control-sm ' +
              (form.estado == 1 ? 'is-valid' : 'is-invalid')
            "
            :value="status[form.estado].text"
          /> -->
           <select
            :class="'form-control form-control-sm form-select' +  (form.estado == 1 ? ' is-valid' : ' is-invalid')"
            v-model="form.estado"
            :disabled="disable.status"
            >
            <option
              :value="1"
            >
              DISPONIBLE
            </option>
            <option
              :value="2"
            >
              NO DISPONIBLE
            </option>
          </select>
        </div>
      </b-col>
    </b-row>
    <div class="separator separator-dashed mt-3 mb-3"></div>
    <b-row v-if="user.roles.name !== 'SuperAdmin'" >
      <b-col md="4">
        <label :class="[dark ? 'text-white': '']" > Asignar a Técnico</label>
        <Select2 v-model="form.brigada" :options="clients" />
      </b-col>
    </b-row>
    <b-row>
      <b-col class="d-flex justify-content-end">
        <div class="form-group">
          <button
            class="btn btn-sm btn-circle btn-link"
            @click="
              () => {
                $router.go(-1);
              }
            "
          >
            <i class="la la-reply"></i> Regresar
          </button>
          <button
            class="btn btn-sm btn-primary btn-circle"
            @click="assignVehicle()"
          >
            <i class="flaticon2-writing"></i>
            {{
              loading
                ? "Cargando..."
                : form.estado == 1
                ? "Asignar"
                : "Actualizar"
            }}
          </button>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import { mapGetters } from "vuex";
import Select2 from "v-select2-component";
import toastr from "toastr";
import axios from "axios";
export default {
  components: {
    Select2,
  },
  data() {
    return {
      id: this.$route.params.id,
      show: false,
      loading: false,
      tvehiculos: [],
      clients: [],
      marcas: [],
      disable: {
        type_vehicle: true,
        marca: true,
        modelo: true,
        status: true,
      },
      form: {
        placa: null,
        marca: null,
        modelo: null,
        tipo: -1,
        brigada: -1,
        estado: null,
      },
    };
  },
  mounted() {
    this.loadTipoVehiculo();
    this.loadMarcas();
    this.loadVehiculo();
    this.loadTech();
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      getContrataForVehicle: "vehicle/getContrataForVehicle",
      dark: "mode/getTheme",
    }),
  },
  methods: {
    loadTech() {
      axios
        .get(`/clientes`)
        .then((res) => {
          let client = [];
          client.push({ id: -1, text: "Seleccione" });
          res.data?.map((el) => {
            client.push({
              id: el.nif,
              text: `${el.nif} - ${el.nombre}`,
            });
          });
          this.clients = client;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    loadVehiculo() {
      axios
        .get(`/vehiculos/${this.id}?base_id=${this.getContrataForVehicle}`)
        .then((res) => {
          const [data] = res.data;
          this.form = data;
          this.form.tipo = data.id_tipovehiculo;
          this.form.marca = data.id_marca;
          this.form.estado = data.estado;
          this.form.brigada = data.brigada 
                            ? data.brigada : this.user.roles.name === 'SuperAdmin' ? undefined : -1;
          if (this.form.tipo === undefined || this.form.tipo === "" || this.form.tipo === null) {
            this.disable.type_vehicle = false;
          } else {
            this.disable.type_vehicle = true;
          }
          if (this.user.roles.name === 'SuperAdmin') {
            this.disable.marca = false; 
            this.disable.modelo = false;
            if ((data.brigada === "-1" || data.brigada === -1) && data.estado === 2) {
              this.disable.status = false;
            }
          } else {
            this.disable.marca  = true; 
            this.disable.modelo = true; 
            this.disable.status = true;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    loadMarcas() {
      axios
        .get(`/vehiculo-marcas?base_id=${this.getContrataForVehicle}`)
        .then((res) => {
          this.marcas = res.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    loadTipoVehiculo() {
      axios
        .get(`/vehiculo-tipos?base_id=${this.getContrataForVehicle}`)
        .then((res) => {
          this.tvehiculos = [];
          let tv = [];
          res.data.map((el) => {
            tv.push({
              id: el.id_tipovehiculo,
              text: el.descripcion.toUpperCase(),
            });
          });
          this.tvehiculos = tv;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    assignVehicle() {
      if (this.form.brigada !== -1 || this.form.modelo === null || this.form.marca === null) {
        this.loading = true;
        axios
          .put(`/vehiculos/${this.id}`, {...this.form, contrata: this.getContrataForVehicle })
          .then((res) => {
            if (res.data.message == "success") {
              this.loadVehiculo();
              this.$swal.fire({
                title: "Información",
                text: res.data.information,
                icon: "success",
              });
            } else {
              this.$swal.fire({
                title: "Información",
                text: res.data.information,
                icon: "warning",
              });
            }
            this.loading = false;
          })
          .catch((e) => {
            console.log(e);
            this.loading = false;
          });
      } else {
        toastr.info(
          `Debe seleccionar una brigada para ${
            this.form.estado == 1 ? "asignar" : "actualizar"
          } el vehículo `
        );
      }
    },
  },
};
</script>
